<template>
    <CCard>      
        <CCardBody>
            <CRow>        
                <div class="col-lg-12 control-section">
                    <div class="content-wrapper">
                      <div id="app">
                          <ejs-tooltip  target=".e-rowcell" >
                            <ejs-grid ref='grid' locale='zh-TW' :dataSource='this.datas'  height='500' :allowExcelExport='true' :queryCellInfo='onQueryCellInfo'
                                :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true' :toolbar='toolbar' 
                                :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' 
                                :load='load' :toolbarClick="toolbarClick" :rowSelected='rowSelected' :recordDoubleClick="pubDoubleClick"  >
                                <e-columns>
                                    <e-column field='notify' headerText='訊息' :isPrimaryKey='true' width='80' :template="imgTemplate"></e-column>   
                                    <e-column field='ua' headerText='採購單號' aria-required="true" :isPrimaryKey='true' width='140'></e-column>              
                                    <e-column field='ub' headerText='驗收單號' width='140' :isPrimaryKey='true'></e-column>       
                                    <e-column field='f_no' headerText='料號' width='120'></e-column>   
                                    <e-column field='f_name' headerText='料名' width='200'></e-column>   
                                    <e-column field='quity' headerText='數量' width='120'></e-column>   
                                    <e-column field='unit' headerText='單位' width='120'></e-column>   
                                    <e-column field='f_date' headerText='預計交貨日' width='140'></e-column> 
                                    <e-column field='invoice_month' headerText='帳款月' width='140'></e-column>   
                                    <e-column field='amount_total' headerText='金額合計' width='140' textAlign="Right" format="N0"></e-column> 
                                    <e-column field='not_taxed_amount' headerText='未稅金額' width='140' textAlign="Right" format="N0"></e-column> 
                                    <e-column field='taxed_amount' headerText='稅額合計' width='140' textAlign="Right" format="N0"></e-column> 
                                    <e-column field='ub_quity' headerText='驗收數量' width='140' textAlign="Right" format="N0"></e-column> 
                                    <e-column field='bad_quity' headerText='不良品數' width='140' textAlign="Right" format="N0"></e-column> 
                                    <e-column field='ub_date' headerText='驗收日期' width='140' textAlign="Right" format="N0"></e-column> 
                                    <e-column field='ub_input' headerText='驗收入庫' width='140' textAlign="Right" format="N0"></e-column>   
                                    <e-column field='ub_pay_qut' headerText='付款數量' width='140' textAlign="Right" format="N0"></e-column>
                                    <e-column field='c_no' headerText='廠商編號' width='120'></e-column>   
                                    <e-column field='c_name' headerText='廠商名稱' width='200'></e-column>                                
                                </e-columns>
                            </ejs-grid>        
                        </ejs-tooltip>
                      </div>                  
                    </div>                      
                </div>  
            </CRow>
            <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>      
        </CCardBody>
        <div class="control-section">
            <ejs-dialog ref="dialogNotifyTemplate" showCloseIcon='true' isModal='true' :visible='false' header='對話視窗' width='700px' closeOnEscape='true' >
               <NotifyTemplate ref="myNotifyTemplate" v-on:onNotifyTemplateClose="onNotifyTemplateItem"></NotifyTemplate>
            </ejs-dialog>
        </div>   
    </CCard>
  </template>
  
  <style lang="scss" src="../../scss/grid.scss"></style>
  <script >
  
    import Vue from "vue";
    import { L10n, enableRipple  } from '@syncfusion/ej2-base';
    import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
    import { TextBoxPlugin, NumericTextBoxPlugin  } from '@syncfusion/ej2-vue-inputs';
    import { ButtonPlugin, CheckBoxPlugin, RadioButtonPlugin  } from '@syncfusion/ej2-vue-buttons';    
    import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
    import { GridComponent, ColumnsDirective, ColumnDirective, GridPlugin, DetailRow, PdfExport, ExcelExport, Sort, Edit, Page, Filter, Reorder, Toolbar, Search } from "@syncfusion/ej2-vue-grids";
    import zhtwLocalization  from '../language/language.json';
    import NotifyTemplate from "./template/NotifyTemplate.vue";
    import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
    import Loading from 'vue-loading-overlay';
    L10n.load(zhtwLocalization);
  
    enableRipple(true);
    Vue.use(DialogPlugin);
    Vue.use(GridPlugin);    
    Vue.use(ButtonPlugin);
    Vue.use(CheckBoxPlugin);
    Vue.use(TextBoxPlugin);
    Vue.use(DropDownListPlugin);
    Vue.use(NumericTextBoxPlugin );
    Vue.use(RadioButtonPlugin);
    Vue.use(TooltipPlugin);
    Vue.use(Loading);
    Vue.prototype.$eventHub = new Vue(); 
    let Loader      = undefined;
    export default Vue.extend({     
        components: {
          'ejs-grid': GridComponent,
          'e-columns': ColumnsDirective,
          'e-column': ColumnDirective,
          'ejs-toast': ToastComponent,
          NotifyTemplate,
        },
        data: function() {
          return {  
            datas: [],
            e_selectData: null,
            position: { X: 'Right', Y: "Bottom" }, ShowBtn: false,
            pageSettings: {pageSize: 10, pageSizes: [10, 50, 100, 200], pageCount: 10 },     
            toolbar: [
                { text: '百家珍通知', tooltipText: '百家珍通知', prefixIcon: 'e-btn-icon e-annotation-edit e-icons e-icon-left', id: 'check' },
                // { text: '異常圖片', tooltipText: '異常圖片', prefixIcon: 'e-btn-icon e-eye e-icons e-icon-left', id: 'Camera' },
                { text: '匯出Excel', tooltipText: '匯出Excel', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' },'Search'],     
            filterSettings: { type: 'Excel' },
            selectionSettings: { persistSelection: true },
            animationSettings: { effect: 'Fade' },
            visible : false,        
            imgTemplate: function () {
                return {
                template: Vue.component('imgTemplate', {
                        template: `<div id="coordinates">
                                <div v-if="data.notify === 0"></div>
                                <div v-if="data.notify === 1"><img src="img/icon/chat.png" class="e-image" width="20px"/></div>
                                <div v-if="data.notify === 2"><img src="img/icon/new-email.png" class="e-image" width="20px"/></div>                                 
                                </div>`,
                        data: function () { return { data: {} }; },
                        computed: { },
                        methods: { }
                    })
                }
            },             
        };
    },         
    mounted: function(){
        
    },
    methods: {           
        beforeRender: function (args) {
            if (args.target.closest("td")) {
                this.$refs.tooltip.content = args.target.innerText;                
            }
        },   
        onQueryCellInfo(args) {     
            if (args.cell) {
                args.cell.classList.add("tooltip-cell");
                args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
            }
        },
        pubDoubleClick: function () {  
            
        },
        editOkClick: function () {           
            this.upData();         
        },
        valueChange: function () {  
            this.isDataChanged = true;
            this.stTime = null;
        },
        load: function() {   
  
        },       
        addAction: function() {
  
        },      
        toolbarClick: function(args) {
          if (args.item.id == "Export") {
            this.$refs.grid.excelExport({ fileName:'採購資料.xlsx' });
          }
          if (args.item.id == "check") {
            if (this.e_selectData == null) {
                this.showMsg('請先選擇一筆資料');
                return;
            }
            this.onNotifyTemplate();
          }
        },   
  
        onNotifyTemplate:function() {
            this.$refs.dialogNotifyTemplate.show();  
            this.$refs.myNotifyTemplate.onload(this.e_selectData.ua, this.e_selectData.f_no, false);
        },
        onNotifyTemplateItem:function() {
            this.$refs.dialogNotifyTemplate.hide();  
            this.getCustomer();
        },
        
        actionComplete: function() {                             
        },
        rowSelected: function(args) {      
            this.e_selectData = args.data;  
              
        },    
        getCustomer: function(no) {    
            this.showLoading();
            this.axios({
                method: 'get',
                baseURL: Vue.prototype.GLOBAL.baseURL,
                url: `/SCM/Detail/Msg?no=${no}`,
                headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
            })
            .then((response) => {       
                this.hideLoading();
                if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
                this.datas = response.data.datas;  
                this.e_selectData = null;
            })
            .catch((error) => {           
                this.showError(error) }
            )             
        },    
        showError: function (error) {     
            this.hideLoading();
            if (error.response.status == 400) {
            for(var key in error.response.data.errors){      
                this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
            }
            return;
            }   
            if (error.response.status == 401) {
            localStorage.removeItem('token'); this.$router.push('/login');
            return;
            }
            this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
        },
        showMsg: function (msg) {
            this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
        },   
        showLoading() {
            Loader = this.$loading.show({
            container: this.$refs.loadingContainer,
            canCancel: true, // default false
            onCancel: this.yourCallbackMethod,
            color: 'red',
            loader: 'dots',  // spinner, dots, bars
            width: 164,
            height: 164,
            backgroundColor: 'black',
            opacity: 0.5,
            zIndex: 999,
            });
        },
        hideLoading() {
            Loader.hide();
        }     
    },
    created() {        
        const no = `${localStorage.getItem('userid')}`
        this.getCustomer(no);
        this.$eventHub.$on('sign', ()=>{ 
            this.$refs.dialogSign.show();
      }); 
    },
    beforeDestroy() {
        this.$eventHub.$off('sign');
    },
    computed: {
    },
  
    provide: {
        grid: [PdfExport, ExcelExport, Sort , DetailRow, Edit, Page, Toolbar, Filter, Reorder, Search]      
    }
    });
  </script>
  
  <style scoped>
      @import "../../scss/grid.scss"
  </style>
  <style lang="scss" src="../../scss/base.scss"></style>